export default "__VITE_ASSET__abcf01c1__"